import _styled from "@emotion/styled/base";
import { css } from '@emotion/react';
import { colors, typography, typeface, getResetByTag, utilityStyles } from './../../styles';
import StyledType from './../type/type.styles';
var defaultStyles = function defaultStyles() {
  return /*#__PURE__*/css("align-items:baseline;display:flex;font-family:", typeface.typefaceBase, ";font-size:", typography.typographyBodyXs, ";line-height:1.429;white-space:normal;&>*{flex-basis:100%;margin:0;}" + (process.env.NODE_ENV === "production" ? "" : ";label:defaultStyles;"));
};
var inverseStyles = function inverseStyles(_ref) {
  var isInverse = _ref.isInverse,
    type = _ref.type;
  if (type === null) {
    return /*#__PURE__*/css(StyledType, "{color:", isInverse ? colors.coolGray_500 : colors.coolGray_800, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:inverseStyles;"));
  } else if (type === 'default') {
    return /*#__PURE__*/css(">", StyledType, "{color:", isInverse ? colors.coolGray_500 : colors.coolGray_800, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:inverseStyles;"));
  }
};
var resetStyles = getResetByTag('div');
var StyledHint = /*#__PURE__*/_styled('div', process.env.NODE_ENV === "production" ? {
  target: "ennhlcc0"
} : {
  target: "ennhlcc0",
  label: "StyledHint"
})(resetStyles, defaultStyles, inverseStyles, utilityStyles);
export default StyledHint;